export const checkIsArrayEmpty = (arr: Array<any> | null | undefined) =>
    !arr?.length;
